// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1B7zt","errorLogs":"styles_errorLogs__3MZV5"};